import React from 'react';
import { Skeleton, Stack } from '@mui/material';

const Placeholder = () => {
  return <Stack spacing={1}>
    <Skeleton height={30} />
    <Skeleton variant="rectangular" height={100} />
  </Stack>
}

export default Placeholder;